import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { isRichTextEditorEnabled } from '@/constants'
import { MARKDOWN_PROSE } from '@/lib/markdown-prose'
import { cn } from '@/lib/utils'

export type MarkdownContentProps = {
  children: string
  className?: string
}

/** Read-only rendered markdown (not HTML source). */
export function MarkdownContent({ children, className }: MarkdownContentProps) {
  const trimmed = children.trim()
  if (!trimmed) return null

  return (
    <div className={cn(MARKDOWN_PROSE, className)}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{trimmed}</ReactMarkdown>
    </div>
  )
}

export type MarkdownBodyProps = {
  children: string
  className?: string
  plainClassName?: string
}

/** Markdown read view when rich text is enabled; plain pre-wrap otherwise. */
export function MarkdownBody({ children, className, plainClassName }: MarkdownBodyProps) {
  const trimmed = children.trim()
  if (!trimmed) return null

  if (isRichTextEditorEnabled()) {
    return <MarkdownContent className={className}>{children}</MarkdownContent>
  }

  return (
    <p className={cn('whitespace-pre-wrap text-sm text-muted-foreground', plainClassName, className)}>
      {trimmed}
    </p>
  )
}
